import { normalizePreserveCase } from 'components/Dashboard/utilities/normalizeString';

export const validatePlaceholders = ({ emailBody, mailMergeFields = [] }) => {
  let htmlBody = document.createElement('div');
  htmlBody.innerHTML = emailBody;
  const normalizedFields = new Set([
    'salutation',
    ...mailMergeFields.map((field) => normalizePreserveCase(field)).filter((field) => field),
  ]);

  const mailMergeSpansWithIds = htmlBody.querySelectorAll('span.crm-mail-merge-substitution');
  const otherSpansWithIds = htmlBody.querySelectorAll('span[id]:not(.crm-mail-merge-substitution)');

  const spansWithDataCrmMailMergeSubstitutionId = htmlBody.querySelectorAll(
    'span[data-crm-mail-merge-substitution-id]'
  );

  const spansWithIds = [...mailMergeSpansWithIds, ...otherSpansWithIds, ...spansWithDataCrmMailMergeSubstitutionId];

  spansWithIds.forEach((span) => {
    const spanId = span.getAttribute('id');
    const normalizedSpanId = normalizePreserveCase(spanId);
    const isSpecialId = spanId === 'email_signature' || spanId === 'nosignature';

    const dataCrmMailMergeSubstitutionId = span.getAttribute('data-crm-mail-merge-substitution-id');
    const normalizedDataCrmMailMergeSubstitutionId = normalizePreserveCase(dataCrmMailMergeSubstitutionId);

    //OP: data-crm-mail-merge-substitution-id exists case
    if (dataCrmMailMergeSubstitutionId) {
      if (!normalizedFields.has(normalizedDataCrmMailMergeSubstitutionId)) {
        const uppercaseText = dataCrmMailMergeSubstitutionId.replace(/-/g, '_').toUpperCase();
        const textNode = document.createTextNode(uppercaseText);
        span.parentNode?.replaceChild(textNode, span);
      }
      return;
      //OP: id exists case
    } else if (span.getAttribute('id') && !isSpecialId && span.classList.contains('crm-mail-merge-substitution')) {
      if (normalizedFields.has(normalizedSpanId)) {
        span.setAttribute('data-crm-mail-merge-substitution-id', normalizedSpanId);
        span.removeAttribute('id');
      } else {
        const uppercaseText = spanId.replace(/-/g, '_').toUpperCase();
        const textNode = document.createTextNode(uppercaseText);
        span.parentNode?.replaceChild(textNode, span);
      }
      return;
      //OP: crm-mail-merge-substitution className exists only case
    } else if (span.classList.contains('crm-mail-merge-substitution')) {
      const textElements = span.querySelectorAll('text');
      let text = '';
      if (textElements.length > 0) {
        text = Array.from(textElements)
          .map((textElement) => textElement.textContent)
          .join('');
      }
      const uppercaseText = text.replace(/-/g, '_').replace(/@/g, '').toUpperCase();
      const textNode = document.createTextNode(uppercaseText);
      span.parentNode?.replaceChild(textNode, span);
      return;
    }
  });

  return htmlBody.innerHTML;
};

export const applyEmailSignatureToBody = ({ emailAddressItem, emailBody, disableChange }) => {
  if (emailAddressItem?.signature) {
    let htmlBody = document.createElement('div');
    htmlBody.innerHTML = emailBody;
    let htmlSignature = htmlBody.querySelector('#email_signature');
    //OP: #nosignature span - means signature was removed on purpose
    let signatureRemovedSpan = htmlBody.querySelector('#nosignature');
    let disableSignatureChange = disableChange && htmlSignature;
    if (!disableSignatureChange && !signatureRemovedSpan) {
      if (!htmlSignature) {
        htmlSignature = document.createElement('div');
        htmlSignature.id = 'email_signature';
      }
      htmlSignature.innerHTML = emailAddressItem.signature;
      htmlBody.appendChild(htmlSignature);
      return htmlBody.innerHTML;
    } else {
      return emailBody;
    }
  } else {
    let htmlBody = document.createElement('div');
    htmlBody.innerHTML = emailBody;
    let htmlSignature = htmlBody.querySelector('#email_signature');
    if (htmlSignature) {
      htmlSignature.remove();
    }
    return htmlBody.innerHTML;
  }
};

export const toggleSignature = ({ emailAddressItem, emailBody }) => {
  let htmlBody = document.createElement('div');
  htmlBody.innerHTML = emailBody;
  let signatureRemovedSpan = htmlBody.querySelector('#nosignature');
  if (signatureRemovedSpan) {
    if (emailAddressItem?.signature) {
      let htmlSignature = document.createElement('div');
      htmlSignature.id = 'email_signature';
      htmlSignature.innerHTML = emailAddressItem.signature;
      htmlBody.appendChild(htmlSignature);
      let signatureRemovedSpanContainer = signatureRemovedSpan.parentNode;
      if (signatureRemovedSpanContainer) {
        signatureRemovedSpanContainer.parentNode.removeChild(signatureRemovedSpanContainer);
      }
      return htmlBody.innerHTML;
    } else {
      return emailBody;
    }
  } else {
    let htmlSignature = htmlBody.querySelector('#email_signature');
    if (htmlSignature) {
      htmlSignature.parentNode.removeChild(htmlSignature);
    }
    let signatureRemovedSpan = document.createElement('span');
    signatureRemovedSpan.id = 'nosignature';
    signatureRemovedSpan.style.visibility = 'hidden';
    htmlBody.appendChild(signatureRemovedSpan);
    return htmlBody.innerHTML;
  }
};
